import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { getAllProperties, propertiesToArray } from '../Functions/FetchProperties';

const ExploreVillas = () => {
    const [locationCounts, setLocationCounts] = useState({
        Karjat: 0,
        Khopoli: 0,
        Lonavala: 0,
        Mahabaleshwar: 0,
        'Pattaya Thailand': 0,
        All: 0
    });

    useEffect(() => {
        const fetchPropertyCounts = async () => {
            try {
                const properties = await getAllProperties();
                const propertiesArray = propertiesToArray(properties);
                
                // Initialize counts
                const counts = {
                    Karjat: 0,
                    Khopoli: 0,
                    Lonavala: 0,
                    Mahabaleshwar: 0,
                    'Pattaya Thailand': 0,
                };
                
                // Count properties by location
                propertiesArray.forEach(property => {
                    if (property.location) {
                        const locationLower = property.location.trim().toLowerCase();
                        
                        // Check for partial matches for all locations
                        if (locationLower.includes('karjat')) {
                            counts['Karjat']++;
                        } else if (locationLower.includes('khopoli')) {
                            counts['Khopoli']++;
                        } else if (locationLower.includes('lonavala')) {
                            counts['Lonavala']++;
                        } else if (locationLower.includes('mahabaleshwar')) {
                            counts['Mahabaleshwar']++;
                        } else if (locationLower.includes('pattaya')) {
                            counts['Pattaya Thailand']++;
                        }
                    }
                });
                
                // Set the total count
                counts.All = propertiesArray.length;
                
                setLocationCounts(counts);
            } catch (error) {
                console.error('Error fetching property counts:', error);
            }
        };

        fetchPropertyCounts();  
    }, []);

    return (
        <div>
            {/* Explore Villas Section */}
            <section className="explore-section">
                <div className="container">
                    <h2 className="section-title text-center mb-5">Explore Properties</h2>
                    <div className="row">
                        <div className="col-md-2 col-4 mb-4">
                            <Link to="/properties?location=Karjat" className="text-decoration-none">
                                <div className="category-icon">
                                    <div className="icon-circle">
                                        <img src="/assets/Images/karjat.png" alt="Pool Villas" className="category-img" />
                                    </div>
                                    <p>Karjat</p>
                                    <span className="property-count">{locationCounts.Karjat} properties</span>
                                </div>
                            </Link>
                        </div>
                        <div className="col-md-2 col-4 mb-4">
                            <Link to="/properties?location=Khopoli" className="text-decoration-none">
                                <div className="category-icon">
                                    <div className="icon-circle">
                                        <img src="/assets/Images/khopoli.jpg" alt="Mountain View" className="category-img" />
                                    </div>
                                    <p>Khopoli</p>
                                    <span className="property-count">{locationCounts.Khopoli} properties</span>
                                </div>
                            </Link>
                        </div>
                        <div className="col-md-2 col-4 mb-4">
                            <Link to="/properties?location=Lonavala" className="text-decoration-none">
                                <div className="category-icon">
                                    <div className="icon-circle">
                                        <img src="/assets/Images/lonavala.jpg" alt="Beach Villas" className="category-img" />
                                    </div>
                                    <p>Lonavala</p>
                                    <span className="property-count">{locationCounts.Lonavala} properties</span>
                                </div>
                            </Link>
                        </div>
                        <div className="col-md-2 col-4 mb-4">
                            <Link to="/properties?location=Mahabaleshwar" className="text-decoration-none">
                                <div className="category-icon">
                                    <div className="icon-circle">
                                        <img src="/assets/Images/mahabaleshwar.jpg" alt="Hill Stations" className="category-img" />
                                    </div>
                                    <p>Mahabaleshwar</p>
                                    <span className="property-count">{locationCounts.Mahabaleshwar} properties</span>
                                </div>
                            </Link>
                        </div>
                        <div className="col-md-2 col-4 mb-4">
                            <Link to="/properties?location=Pattaya, Thailand" className="text-decoration-none">
                                <div className="category-icon">
                                    <div className="icon-circle">
                                        <img src="/assets/Images/pattaya.jpg" alt="Nature Retreats" className="category-img" />
                                    </div>
                                    <p>Pattaya Thailand</p>
                                    <span className="property-count">{locationCounts['Pattaya Thailand']} properties</span>
                                </div>
                            </Link>
                        </div>
                        <div className="col-md-2 col-4 mb-4">
                            <Link to="/properties" className="text-decoration-none">
                                <div className="category-icon">
                                    <div className="icon-circle">
                                        <img src="/assets/Images/all.jpg" alt="Sunny Escapes" className="category-img" />
                                    </div>
                                    <p>All</p>
                                    <span className="property-count">{locationCounts.All} properties</span>
                                </div>
                            </Link>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default ExploreVillas;